import ArrowTriangleheadSwapCircleFill from './ArrowTriangleheadSwapCircleFill';

export default ArrowTriangleheadSwapCircleFill;
